import { render, staticRenderFns } from "./01zhihuichengshi.vue?vue&type=template&id=ba94e02c&scoped=true&"
import script from "./01zhihuichengshi.vue?vue&type=script&lang=js&"
export * from "./01zhihuichengshi.vue?vue&type=script&lang=js&"
import style0 from "./01zhihuichengshi.vue?vue&type=style&index=0&id=ba94e02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba94e02c",
  null
  
)

export default component.exports